module.exports = __webpack_public_path__ + "static/img/wavm8s-018-ware-2018-edition.969d849.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wav/wavm8s-018-ware-2018-edition.png
// module id = NKvf
// module chunks = 0